import { Check, Copy } from 'lucide-react'
import type { ElementType } from 'react'
import { useState } from 'react'
import {
  InputGroup,
  InputGroupAddon,
  InputGroupButton,
  InputGroupInput,
  InputGroupText,
} from '@/components/ui/input-group'
import { Label } from '@/components/ui/label'
import { cn } from '@/utils/cn'

/** Read-only value with a copy-to-clipboard button. `copied` is UI-only state. */
export function CopyableField({
  label,
  value,
  icon: Icon,
  mono,
}: {
  label: string
  value: string
  icon?: ElementType
  mono?: boolean
}) {
  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    await navigator.clipboard.writeText(value)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <div className="space-y-1.5">
      <Label className="text-muted-foreground text-xs font-normal">{label}</Label>
      <InputGroup>
        {Icon && (
          <InputGroupAddon align="inline-start">
            <InputGroupText>
              <Icon />
            </InputGroupText>
          </InputGroupAddon>
        )}
        <InputGroupInput readOnly value={value} className={cn(mono && 'font-mono')} />
        <InputGroupAddon align="inline-end">
          <InputGroupButton size="icon-xs" variant="ghost" onClick={handleCopy}>
            {copied ? <Check className="text-success" /> : <Copy />}
          </InputGroupButton>
        </InputGroupAddon>
      </InputGroup>
    </div>
  )
}
